<template>
  <router-link
    v-if="item.route"
    v-slot="{ href, navigate }"
    :to="{ name: item.route, params: item.params }"
    custom
  >
    <a
      v-ripple
      v-tooltip.bottom="item.tooltip"
      v-bind="props.action"
      class="flex px-[14px] py-[7px] align-items-center rounded"
      :href="href"
      @click="navigate"
    >
      <img
        v-if="isImageIcon(item.icon)"
        :src="item.icon"
        :class="item.iconClass ?? 'w-4 h-4'"
      />

      <span
        v-else-if="item.icon"
        :class="item.icon"
      />
      <span
        v-if="item.label"
        class="truncate ml-2"
        :class="item.labelClass"
        >{{ item.label }}</span
      >
      <Badge
        v-if="item.badge"
        :class="{ 'ml-auto': !root, 'ml-2': root }"
        :value="item.badge"
      />
      <span
        v-if="item.shortcut"
        class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
        >{{ item.shortcut }}</span
      >
    </a>
  </router-link>

  <a
    v-else
    v-ripple
    v-tooltip.bottom="item.tooltip"
    v-bind="props.action"
    class="flex px-[14px] py-[7px] align-items-center rounded"
  >
    <img
      v-if="isImageIcon(item.icon)"
      :src="item.icon"
      :class="item.iconClass ?? 'w-4 h-4'"
    />

    <span
      v-else-if="item.icon"
      :class="item.icon"
    />
    <span
      v-if="item.label"
      class="truncate ml-2"
      :class="item.labelClass"
      >{{ item.label }}</span
    >
    <Badge
      v-if="item.badge"
      :class="{ 'ml-auto': !root, 'ml-2': root }"
      :value="item.badge"
    />
    <span
      v-if="item.shortcut"
      class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
      >{{ item.shortcut }}</span
    >
  </a>
</template>

<script setup lang="ts">
import Badge from 'primevue/badge'
import { MenubarRouterBindProps } from 'primevue/menubar'
import type { MenuItem } from 'primevue/menuitem'

defineProps<{
  root: boolean
  item: MenuItem
  props: MenubarRouterBindProps
  hasSubmenu?: boolean | MenuItem[]
}>()

function isImageIcon(icon?: string): boolean {
  if (!icon) return false

  return !icon.startsWith('pi ')
}
</script>
